// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1sT0J","footer":"ModalFilter_footer__2GxfV"};